<ng-container *ngIf="options && options.length">
	<bb-button
		*ngFor="let option of options" (click)="onOptionClicked(option)"
		[active]="selectedOption === option.itype || selectedOption === option.label"
	>{{ option.label | translate }}</bb-button>
</ng-container>
